/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Api
 * TDM Deal Registration API
 * OpenAPI spec version: 0.1.0
 */
export interface HealthStatus {
  status: string;
}

export interface DbPoolSnapshot {
  /** Total connections in the pool */
  total: number;
  /** Idle (available) connections */
  idle: number;
  /** Queries waiting for a connection */
  waiting: number;
  capturedAt: string;
}

export interface DbSlowQueryStats {
  /** Start of the observation window (typically 1 hour ago) */
  windowStartAt: string;
  /** Number of slow queries observed in the window */
  count: number;
  /** 95th percentile duration in milliseconds (null if no slow queries) */
  p95Ms?: number | null;
}

export interface DbHealthThresholds {
  /** Slow query warn threshold in ms */
  warnMs: number;
  /** Slow query error threshold in ms */
  errorMs: number;
}

export interface DbHealthSnapshot {
  pool: DbPoolSnapshot;
  slowQueries: DbSlowQueryStats;
  thresholds: DbHealthThresholds;
}

export type SystemHealthStatus =
  (typeof SystemHealthStatus)[keyof typeof SystemHealthStatus];

export const SystemHealthStatus = {
  ok: "ok",
  warning: "warning",
  error: "error",
  unknown: "unknown",
} as const;

export interface SystemHealthItem {
  id: string;
  label: string;
  status: SystemHealthStatus;
  message?: string;
  lastCheckedAt: string;
  actionLabel?: string;
  actionHref?: string;
}

export interface SystemHealthReport {
  items: SystemHealthItem[];
  cachedUntil: string;
}

export type MeMailboxProvider =
  (typeof MeMailboxProvider)[keyof typeof MeMailboxProvider];

export const MeMailboxProvider = {
  google: "google",
  microsoft: "microsoft",
} as const;

export interface Me {
  id: string;
  email: string;
  name?: string;
  isAdmin: boolean;
  hasMailbox: boolean;
  mailboxProvider?: MeMailboxProvider;
  mailboxEmail?: string;
}

/**
 * cc = copy is visible to supplier; bcc = copy is hidden.
 */
export type CopyOnRegPrefMode =
  (typeof CopyOnRegPrefMode)[keyof typeof CopyOnRegPrefMode];

export const CopyOnRegPrefMode = {
  cc: "cc",
  bcc: "bcc",
} as const;

/**
 * initial = initial registration only; all = initial + follow-ups.
 */
export type CopyOnRegPrefScope =
  (typeof CopyOnRegPrefScope)[keyof typeof CopyOnRegPrefScope];

export const CopyOnRegPrefScope = {
  initial: "initial",
  all: "all",
} as const;

export interface CopyOnRegPref {
  /** Whether the user wants a copy of each registration email they send. */
  enabled: boolean;
  /** cc = copy is visible to supplier; bcc = copy is hidden. */
  mode?: CopyOnRegPrefMode;
  /** initial = initial registration only; all = initial + follow-ups. */
  scope?: CopyOnRegPrefScope;
}

export type UpdateCopyOnRegPrefRequestMode =
  (typeof UpdateCopyOnRegPrefRequestMode)[keyof typeof UpdateCopyOnRegPrefRequestMode];

export const UpdateCopyOnRegPrefRequestMode = {
  cc: "cc",
  bcc: "bcc",
} as const;

export type UpdateCopyOnRegPrefRequestScope =
  (typeof UpdateCopyOnRegPrefRequestScope)[keyof typeof UpdateCopyOnRegPrefRequestScope];

export const UpdateCopyOnRegPrefRequestScope = {
  initial: "initial",
  all: "all",
} as const;

export interface UpdateCopyOnRegPrefRequest {
  enabled: boolean;
  mode?: UpdateCopyOnRegPrefRequestMode;
  scope?: UpdateCopyOnRegPrefRequestScope;
}

export interface SupportEmailPref {
  /** Whether the user wants to receive email notifications about updates to their support tickets (status changes and admin replies). */
  enabled: boolean;
}

export type MailboxConnectionProvider =
  (typeof MailboxConnectionProvider)[keyof typeof MailboxConnectionProvider];

export const MailboxConnectionProvider = {
  google: "google",
  microsoft: "microsoft",
} as const;

export interface MailboxConnection {
  connected: boolean;
  provider?: MailboxConnectionProvider;
  email?: string;
  connectedAt?: string;
}

export type SalesforceStatusEnvironment =
  (typeof SalesforceStatusEnvironment)[keyof typeof SalesforceStatusEnvironment];

export const SalesforceStatusEnvironment = {
  sandbox: "sandbox",
  production: "production",
  unknown: "unknown",
} as const;

export interface SalesforceStatus {
  connected: boolean;
  environment: SalesforceStatusEnvironment;
  instanceUrl?: string;
  error?: string;
  lastAuthCheck?: string;
  lastAuthError?: string;
}

export interface SalesforceAuthHealth {
  lastAuthCheck?: string;
  lastAuthError?: string;
}

export interface SalesforceAuthCheckResult {
  ok: boolean;
  error?: string;
  skipped?: boolean;
}

export type SalesforceConfigSource =
  (typeof SalesforceConfigSource)[keyof typeof SalesforceConfigSource];

export const SalesforceConfigSource = {
  env: "env",
  db: "db",
} as const;

export interface SalesforceConfig {
  configured: boolean;
  source?: SalesforceConfigSource;
  loginUrl?: string;
  clientId?: string;
  username?: string;
  privateKeyMasked?: string;
  mrrField?: string;
  tcvField?: string;
  tdmDealIdField?: string;
  routingBasisField?: string;
  supportedStatesField?: string;
  partnerAccountFilter?: string;
  supplierAccountFilter?: string;
  updatedByEmail?: string;
  updatedAt?: string;
}

export interface SalesforceConfigInput {
  loginUrl: string;
  clientId: string;
  username: string;
  privateKey: string;
  mrrField?: string;
  tcvField?: string;
  tdmDealIdField?: string;
  routingBasisField?: string;
  supportedStatesField?: string;
  partnerAccountFilter?: string;
  supplierAccountFilter?: string;
}

/**
 * Optional Salesforce credentials to test. Any field omitted is loaded from the saved per-user configuration; if privateKey is omitted, the encrypted key is decrypted server-side. To test currently-saved credentials as-is, send an empty body.
 */
export interface SalesforceTestRequest {
  loginUrl?: string;
  clientId?: string;
  username?: string;
  privateKey?: string;
}

export interface SalesforceTestResult {
  success: boolean;
  instanceUrl?: string;
  username?: string;
  error?: string;
}

export type SfFieldCheckResultSobject =
  (typeof SfFieldCheckResultSobject)[keyof typeof SfFieldCheckResultSobject];

export const SfFieldCheckResultSobject = {
  Account: "Account",
  Contact: "Contact",
} as const;

export interface SfFieldCheckResult {
  envVar: string;
  sobject: SfFieldCheckResultSobject;
  configuredField: string;
  isDefault: boolean;
  resolved: boolean;
  label?: string;
  type?: string;
  error?: string;
}

export type SfFieldCheckReportSupplierFilter = {
  value: string;
  isDefault: boolean;
};

export interface SfFieldCheckReport {
  configured: boolean;
  connected: boolean;
  environment?: string;
  supplierFilter?: SfFieldCheckReportSupplierFilter;
  fields: SfFieldCheckResult[];
  error?: string;
}

export interface SalesforceOpportunitySummary {
  id: string;
  name: string;
  accountName: string;
  stageName: string;
  amount?: number;
  closeDate?: string;
  ownerName?: string;
}

export interface Address {
  addressLine1?: string;
  addressLine2?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  country?: string;
}

export interface SalesforceOpportunity {
  id: string;
  name: string;
  accountName: string;
  accountId?: string;
  stageName?: string;
  amount?: number;
  mrr?: number;
  tcv?: number;
  closeDate?: string;
  ownerName?: string;
  ownerEmail?: string;
  primaryContactName?: string;
  primaryContactEmail?: string;
  primaryContactPhone?: string;
  billingAddress?: Address;
  products?: string[];
  notes?: string;
}

export interface ChannelManager {
  id: string;
  name: string;
  email: string;
  phone?: string;
  title?: string;
  accountId?: string;
  accountName: string;
}

/**
 * Color-coded staleness based on configured thresholds. none = no sent registrations.
 */
export type DealStaleness =
  | (typeof DealStaleness)[keyof typeof DealStaleness]
  | null;

export const DealStaleness = {
  none: "none",
  green: "green",
  yellow: "yellow",
  red: "red",
} as const;

export interface Deal {
  id: string;
  sfOpportunityId?: string;
  sfAccountId?: string;
  accountName: string;
  opportunityName: string;
  ownerName?: string;
  ownerEmail: string;
  primaryContactName?: string;
  primaryContactEmail?: string;
  primaryContactPhone?: string;
  billingAddress?: Address;
  products?: string[];
  mrr?: number;
  tcv?: number;
  closeDate?: string;
  notes?: string;
  registrationCount?: number;
  /** Days since the most recently sent registration was sent. Null if no registrations have been sent. */
  daysSinceSent?: number | null;
  /** Days since the most recent reply was received across all registrations for this deal. Null if no replies received. */
  daysSinceReply?: number | null;
  /** Color-coded staleness based on configured thresholds. none = no sent registrations. */
  staleness?: DealStaleness;
  createdAt: string;
  updatedAt: string;
}

export type RegistrationStatus =
  (typeof RegistrationStatus)[keyof typeof RegistrationStatus];

export const RegistrationStatus = {
  draft: "draft",
  sent: "sent",
  accepted: "accepted",
  bid: "bid",
  no_bid: "no_bid",
  more_info: "more_info",
  expired: "expired",
  failed: "failed",
  duplicate_skipped: "duplicate_skipped",
} as const;

export interface Registration {
  id: string;
  dealId: string;
  dealAccountName?: string;
  dealOpportunityName?: string;
  templateId?: string;
  templateName?: string;
  technology?: string;
  supplierContactId?: string;
  supplierContactName?: string;
  supplierContactEmail?: string;
  supplierAccountName?: string;
  senderEmail?: string;
  senderName?: string;
  subject?: string;
  status: RegistrationStatus;
  sentAt?: string;
  lastReplyAt?: string;
  notes?: string;
  createdAt: string;
  updatedAt?: string;
}

export type DealWithRegistrations = Deal & {
  registrations: Registration[];
};

export interface CreateDealRequest {
  sfOpportunityId: string;
  notes?: string;
}

export interface MailboxPollHealth {
  id: string;
  provider: string;
  email: string;
  lastPolledAt?: string | null;
  lastPollError?: string | null;
  isPolling: boolean;
}

export interface MailboxPollHealthReport {
  mailboxes: MailboxPollHealth[];
}

export type AuditLogEntryBefore = { [key: string]: unknown } | null;

export type AuditLogEntryAfter = { [key: string]: unknown } | null;

export interface AuditLogEntry {
  id: string;
  createdAt: string;
  actorId?: string | null;
  actorEmail?: string | null;
  action: string;
  targetType?: string | null;
  targetId?: string | null;
  summary: string;
  before?: AuditLogEntryBefore;
  after?: AuditLogEntryAfter;
  requestId?: string | null;
  ip?: string | null;
}

export interface ListAuditLogResult {
  entries: AuditLogEntry[];
  limit: number;
  offset: number;
}

export interface ApplyReplySuggestionRequest {
  status?: string;
}

export interface ApplyReplySuggestionResult {
  id: string;
  status: string;
}

export type SendFollowUpRequestExtraFields = { [key: string]: unknown };

export interface SendFollowUpRequest {
  templateId: string;
  extraFields?: SendFollowUpRequestExtraFields;
}

export type PreviewOneRequestExtraFields = { [key: string]: unknown };

export interface PreviewOneRequest {
  templateId: string;
  supplierContactId: string;
  /** If supplied, replaces the supplier's stored email in the rendered preview's To field. */
  toAddressOverride?: string;
  extraFields?: PreviewOneRequestExtraFields;
}

export type SendOneRequestExtraFields = { [key: string]: unknown };

/**
 * Per-send override for copy-on-registration. off = no copy; cc = visible copy; bcc = hidden copy. Omit to use the user's default preference.
 */
export type SendOneRequestCopyMode =
  (typeof SendOneRequestCopyMode)[keyof typeof SendOneRequestCopyMode];

export const SendOneRequestCopyMode = {
  off: "off",
  cc: "cc",
  bcc: "bcc",
} as const;

export interface SendOneRequest {
  templateId: string;
  supplierContactId: string;
  /** Final To address (validated as email server-side). */
  toAddress: string;
  subject: string;
  body: string;
  extraFields?: SendOneRequestExtraFields;
  overrideDuplicate?: boolean;
  /** Per-send override for copy-on-registration. off = no copy; cc = visible copy; bcc = hidden copy. Omit to use the user's default preference. */
  copyMode?: SendOneRequestCopyMode;
}

export interface SendOneResponse {
  registration: Registration;
}

export interface SendError {
  error: string;
  code: string;
  providerMessage?: string;
  priorRegistrationId?: string;
}

export interface EmailPreview {
  supplierContactId: string;
  supplierName: string;
  /** Resolved To address (override applied if provided). */
  supplierEmail: string;
  /** The supplier contact's email on file. Empty string if none. */
  supplierStoredEmail?: string;
  supplierAccountName: string;
  subject: string;
  body: string;
  isDuplicate: boolean;
  priorRegistrationId?: string;
  overrideApplied?: boolean;
  originalSupplierName?: string;
  originalSupplierEmail?: string;
}

export type RegistrationJobStatusStatus =
  (typeof RegistrationJobStatusStatus)[keyof typeof RegistrationJobStatusStatus];

export const RegistrationJobStatusStatus = {
  queued: "queued",
  running: "running",
  done: "done",
  failed: "failed",
  cancelled: "cancelled",
} as const;

export interface RegistrationJobStatus {
  jobId: string;
  status: RegistrationJobStatusStatus;
  attempts: number;
  maxAttempts: number;
  lastError?: string | null;
  createdAt: string;
  runAt: string;
  completedAt?: string | null;
}

export type RegistrationJobStatusMapStatuses = {
  [key: string]: RegistrationJobStatus;
};

export interface RegistrationJobStatusMap {
  statuses: RegistrationJobStatusMapStatuses;
}

export type RegistrationDetailMergedFields = { [key: string]: unknown };

export interface RegistrationEvent {
  id: string;
  type: string;
  message?: string;
  createdAt: string;
  actorEmail?: string;
}

export type RegistrationDetail = Registration & {
  body: string;
  mergedFields?: RegistrationDetailMergedFields;
  events: RegistrationEvent[];
};

export type UpdateRegistrationRequestStatus =
  (typeof UpdateRegistrationRequestStatus)[keyof typeof UpdateRegistrationRequestStatus];

export const UpdateRegistrationRequestStatus = {
  draft: "draft",
  sent: "sent",
  accepted: "accepted",
  bid: "bid",
  no_bid: "no_bid",
  more_info: "more_info",
  expired: "expired",
  failed: "failed",
  duplicate_skipped: "duplicate_skipped",
} as const;

export interface UpdateRegistrationRequest {
  status: UpdateRegistrationRequestStatus;
  notes?: string;
}

export type TemplateFieldType =
  (typeof TemplateFieldType)[keyof typeof TemplateFieldType];

export const TemplateFieldType = {
  text: "text",
  textarea: "textarea",
  number: "number",
  select: "select",
} as const;

export interface TemplateField {
  key: string;
  label: string;
  type: TemplateFieldType;
  required?: boolean;
  options?: string[];
  helpText?: string;
}

export type TemplatePurpose =
  (typeof TemplatePurpose)[keyof typeof TemplatePurpose];

export const TemplatePurpose = {
  registration: "registration",
  follow_up: "follow_up",
  internal_notification: "internal_notification",
  requester_summary: "requester_summary",
} as const;

export type TemplateBodyFormat =
  (typeof TemplateBodyFormat)[keyof typeof TemplateBodyFormat];

export const TemplateBodyFormat = {
  text: "text",
  html: "html",
} as const;

export interface TechnologyTemplate {
  id: string;
  name: string;
  technology: string;
  purpose: TemplatePurpose;
  description?: string;
  subjectTemplate: string;
  bodyTemplate: string;
  bodyFormat: TemplateBodyFormat;
  fields: TemplateField[];
  createdAt: string;
  updatedAt: string;
}

export interface SendSessionSummaryRequest {
  registrationIds: string[];
}

export interface SendSessionSummaryResult {
  sent: boolean;
  reason?: string;
}

export type TemplatePreviewSendRequestBodyFormat =
  (typeof TemplatePreviewSendRequestBodyFormat)[keyof typeof TemplatePreviewSendRequestBodyFormat];

export const TemplatePreviewSendRequestBodyFormat = {
  text: "text",
  html: "html",
} as const;

/**
 * Optional per-tag overrides for sample merge values. Keys are merge-tag
names (e.g. "accountName" or dotted paths like "supplier.name"); values
are the strings to substitute. Empty/missing entries fall back to the
built-in defaults.

 */
export type TemplatePreviewSendRequestSampleValueOverrides = {
  [key: string]: string;
};

/**
 * A draft template (does not need to be saved) to render and send to the requesting admin's email.
 */
export interface TemplatePreviewSendRequest {
  purpose?: TemplatePurpose;
  subjectTemplate: string;
  bodyTemplate: string;
  bodyFormat?: TemplatePreviewSendRequestBodyFormat;
  fields?: TemplateField[];
  /** Optional per-tag overrides for sample merge values. Keys are merge-tag
names (e.g. "accountName" or dotted paths like "supplier.name"); values
are the strings to substitute. Empty/missing entries fall back to the
built-in defaults.
 */
  sampleValueOverrides?: TemplatePreviewSendRequestSampleValueOverrides;
}

export interface TemplatePreviewSendResponse {
  sent: boolean;
  /** The email address the test was sent to. */
  deliveredTo: string;
  /** Mailbox provider used (e.g., gmail, microsoft). */
  provider?: string;
}

export interface TemplateRequest {
  name: string;
  technology: string;
  purpose?: TemplatePurpose;
  description?: string;
  subjectTemplate: string;
  bodyTemplate: string;
  bodyFormat?: TemplateBodyFormat;
  fields?: TemplateField[];
}

export type ReportRegistrationsOverTimeDataItem = {
  date: string;
  status: string;
  count: number;
};

export interface ReportRegistrationsOverTime {
  data: ReportRegistrationsOverTimeDataItem[];
}

export interface ReportSupplierLeaderboardItem {
  accountName: string;
  total: number;
  positive: number;
  replied: number;
  approvalRate: number;
  replyRate: number;
}

export interface ReportSupplierLeaderboard {
  suppliers: ReportSupplierLeaderboardItem[];
}

export interface ReportRepPerformanceItem {
  userId: string;
  name: string;
  email: string;
  total: number;
  replied: number;
  replyRate: number;
  avgDaysToReply?: number | null;
  medianDaysToReply?: number | null;
}

export interface ReportRepPerformance {
  reps: ReportRepPerformanceItem[];
}

export interface ReportTimingBucket {
  bucket: string;
  count: number;
}

export interface ReportTiming {
  avgDaysToReply?: number | null;
  medianDaysToReply?: number | null;
  totalSent: number;
  totalReplied: number;
  replyRate: number;
  avgDaysToApproval?: number | null;
  medianDaysToApproval?: number | null;
  totalApproved: number;
  distribution: ReportTimingBucket[];
}

export interface ReportFollowUpGroup {
  total: number;
  replied: number;
  replyRate: number;
}

export interface ReportFollowUpImpact {
  withFollowUp: ReportFollowUpGroup;
  withoutFollowUp: ReportFollowUpGroup;
}

export interface ReportPipelineByMonthItem {
  month: string;
  dealCount: number;
  totalTcv: number;
  totalMrr: number;
}

export interface ReportPipelineByMonth {
  data: ReportPipelineByMonthItem[];
}

export type DashboardSummaryTotals = {
  deals: number;
  registrations: number;
  suppliers: number;
  openRegistrations: number;
};

export type DashboardSummaryByStatusItem = {
  status: string;
  count: number;
};

export type DashboardSummaryByTechnologyItem = {
  technology: string;
  count: number;
};

export type DashboardSummaryTopSuppliersItem = {
  accountName: string;
  count: number;
};

export interface DashboardSummary {
  totals: DashboardSummaryTotals;
  byStatus: DashboardSummaryByStatusItem[];
  byTechnology: DashboardSummaryByTechnologyItem[];
  topSuppliers: DashboardSummaryTopSuppliersItem[];
}

export interface ChannelManagerOverride {
  name: string;
  email: string;
  phone?: string;
  title?: string;
  notes?: string;
  accountName: string;
  submittedByEmail?: string;
  adminNotifiedAt?: string;
  createdAt: string;
  updatedAt: string;
}

export interface ChannelManagerOverrideRequest {
  name: string;
  email: string;
  phone?: string;
  title?: string;
  notes?: string;
}

export interface Supplier {
  sfAccountId: string;
  accountName: string;
  channelManagers: ChannelManager[];
  importedChannelManagers?: ChannelManager[];
  usedInDeal: boolean;
  registrationCount?: number;
  hasOverride: boolean;
  override?: ChannelManagerOverride;
}

/**
 * Present when a Salesforce-imported supplier was auto-linked to a pre-existing
TDM supplier (score >= 0.85). Records the timestamp, score, and signals that
were used to make the link, so admins can audit and trust the auto-linking.

 */
export interface SupplierAutoLink {
  linkedAt: string;
  score: number;
  signals: string[];
}

/**
 * Present when a supplier was created from a Salesforce account that had a
near-match (0.6 ≤ score < 0.85) against an existing TDM supplier without an
SF Account ID. Admins should review and either merge or dismiss.

 */
export interface SupplierNeedsReview {
  matchSupplierId: string;
  matchSupplierName?: string;
  score: number;
  signals: string[];
}

export interface TdmSupplierContact {
  id: string;
  name: string;
  email: string;
  phone?: string;
  title?: string;
  isPrimary?: boolean;
}

export type TdmSupplierSource =
  (typeof TdmSupplierSource)[keyof typeof TdmSupplierSource];

export const TdmSupplierSource = {
  manual: "manual",
  salesforce: "salesforce",
} as const;

export interface TdmSupplier {
  id: string;
  name: string;
  website?: string;
  address?: Address;
  notes?: string;
  sfAccountId?: string;
  source: TdmSupplierSource;
  channelManagers: TdmSupplierContact[];
  sfChannelManagers?: ChannelManager[];
  usedInDeal: boolean;
  registrationCount?: number;
  hasOverride: boolean;
  override?: ChannelManagerOverride;
  needsReview?: SupplierNeedsReview;
  autoLinked?: SupplierAutoLink;
  deletedAt?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface TdmSupplierContactInput {
  name: string;
  email: string;
  phone?: string;
  title?: string;
  isPrimary?: boolean;
}

export interface CreateSupplierRequest {
  name: string;
  website?: string;
  address?: Address;
  notes?: string;
  channelManagers?: TdmSupplierContactInput[];
  requestSfAdd?: boolean;
  /** Set to true to proceed despite detected high-confidence duplicates. */
  acknowledgedDuplicates?: boolean;
}

export interface UpdateSupplierRequest {
  name?: string;
  website?: string;
  address?: Address;
  notes?: string;
  channelManagers?: TdmSupplierContactInput[];
  /** Send a "request add to Salesforce" email (only when supplier has no sfAccountId) */
  requestSfAdd?: boolean;
}

export interface MatchCheckRequest {
  name?: string;
  website?: string;
  sfAccountId?: string;
  contactEmails?: string[];
  excludeId?: string;
}

export interface MatchCandidate {
  id: string;
  name: string;
  score: number;
  signals: string[];
  sfAccountId?: string;
  source?: string;
}

export interface SfAccountForImport {
  id: string;
  name: string;
  channelManagers: ChannelManager[];
  /** TDM supplier id this likely duplicates */
  duplicateOfId?: string;
  duplicateOfName?: string;
  duplicateScore?: number;
  alreadyImported?: boolean;
}

export interface BulkImportRequest {
  sfAccountIds: string[];
}

export interface MergeSupplierRequest {
  /** The supplier id to merge INTO (keep) */
  targetId: string;
}

export interface ActivityItem {
  id: string;
  type: string;
  message: string;
  registrationId?: string;
  dealId?: string;
  actorEmail?: string;
  createdAt: string;
}

export type ReportsScheduleConfigFrequency =
  (typeof ReportsScheduleConfigFrequency)[keyof typeof ReportsScheduleConfigFrequency];

export const ReportsScheduleConfigFrequency = {
  off: "off",
  weekly: "weekly",
  monthly: "monthly",
} as const;

export interface ReportsScheduleConfig {
  frequency: ReportsScheduleConfigFrequency;
  /**
   * 0=Sunday … 6=Saturday. Used when frequency=weekly.
   * @minimum 0
   * @maximum 6
   */
  dayOfWeek: number;
  /**
   * Used when frequency=monthly.
   * @minimum 1
   * @maximum 28
   */
  dayOfMonth: number;
  /**
   * Hour (UTC) at which the report should fire.
   * @minimum 0
   * @maximum 23
   */
  hourUtc: number;
  recipients: string[];
  /** Also send to all admin users + the configured support email. */
  includeAdmins: boolean;
}

export type ReportsScheduleLastStatusTrigger =
  (typeof ReportsScheduleLastStatusTrigger)[keyof typeof ReportsScheduleLastStatusTrigger];

export const ReportsScheduleLastStatusTrigger = {
  schedule: "schedule",
  manual: "manual",
} as const;

export interface ReportsScheduleLastStatus {
  ok: boolean;
  sentAt: string;
  recipientsCount: number;
  recipients: string[];
  periodFrom: string;
  periodTo: string;
  trigger: ReportsScheduleLastStatusTrigger;
  error?: string | null;
}

export interface AdminSettings {
  /** The admin-configured support notification email, if set. */
  supportEmail?: string | null;
  /** The email address that will actually receive support notifications (configured value or env-var fallback). */
  supportEmailEffective: string | null;
  /** The fallback support email loaded from the SUPPORT_EMAIL_TO env var, if any. */
  supportEmailFromEnv: string | null;
  /**
   * The interval (in hours) at which the backup verification cron runs. Applied at server startup.
   * @minimum 1
   * @maximum 168
   */
  backupVerifyIntervalHours: number;
  /** The default interval (in hours) used when no admin override is configured. */
  backupVerifyIntervalHoursDefault: number;
  /** Minimum allowed interval, in hours. */
  backupVerifyIntervalHoursMin: number;
  /** Maximum allowed interval, in hours. */
  backupVerifyIntervalHoursMax: number;
  /** Days after which a deal registration turns yellow (warning). */
  staleYellowDays: number;
  /** Days after which a deal registration turns red (critical). */
  staleRedDays: number;
  /** Default yellow threshold in days. */
  staleYellowDaysDefault: number;
  /** Default red threshold in days. */
  staleRedDaysDefault: number;
  staleYellowDaysMin: number;
  staleYellowDaysMax: number;
  staleRedDaysMin: number;
  staleRedDaysMax: number;
  reportsSchedule: ReportsScheduleConfig;
  /** ISO timestamp of the last scheduled-report email sent. */
  reportsScheduleLastSentAt?: string | null;
  /** ISO timestamp of the next scheduled fire time (null if frequency is "off"). */
  reportsScheduleNextScheduledAt?: string | null;
  reportsScheduleLastStatus?: ReportsScheduleLastStatus | null;
  /** Maximum number of explicit recipient emails allowed in the schedule config. */
  reportsScheduleMaxRecipients: number;
  /** Days before expiry to start warning admins about an aging credential. */
  credentialWarnDays: number;
  /** Maximum age (in days) for the encryption key before it should be rotated. */
  encryptionKeyMaxAgeDays: number;
  /** Maximum age (in days) for a mailbox OAuth token before it should be reconnected. */
  mailboxTokenMaxAgeDays: number;
  /** Maximum age (in days) for Salesforce credentials before they should be rotated. */
  sfCredentialMaxAgeDays: number;
  credentialWarnDaysDefault: number;
  encryptionKeyMaxAgeDaysDefault: number;
  mailboxTokenMaxAgeDaysDefault: number;
  sfCredentialMaxAgeDaysDefault: number;
  credentialWarnDaysMin: number;
  credentialWarnDaysMax: number;
  credentialMaxAgeDaysMin: number;
  credentialMaxAgeDaysMax: number;
}

/**
 * Window to use for the manual send. Defaults to "weekly".
 */
export type RunScheduledReportRequestFrequency =
  (typeof RunScheduledReportRequestFrequency)[keyof typeof RunScheduledReportRequestFrequency];

export const RunScheduledReportRequestFrequency = {
  weekly: "weekly",
  monthly: "monthly",
} as const;

export interface RunScheduledReportRequest {
  /** Window to use for the manual send. Defaults to "weekly". */
  frequency?: RunScheduledReportRequestFrequency;
}

export interface RunScheduledReportResult {
  ok: boolean;
  recipients: string[];
  recipientsCount: number;
  periodFrom: string;
  periodTo: string;
  error?: string | null;
}

export interface DemoDataResetCleared {
  deals: number;
  supplierContacts: number;
  suppliers: number;
  supportTickets: number;
}

export interface DemoDataResetResult {
  ok: boolean;
  cleared: DemoDataResetCleared;
}

export type SavedFilterFilterJson = { [key: string]: unknown };

export interface SavedFilter {
  id: string;
  name: string;
  isShared: boolean;
  filterJson: SavedFilterFilterJson;
  /** Whether the current user is the owner of this saved filter. */
  isOwn: boolean;
  createdAt: string;
  updatedAt: string;
}

export type CreateSavedFilterRequestFilterJson = { [key: string]: unknown };

export interface CreateSavedFilterRequest {
  name: string;
  isShared?: boolean;
  filterJson: CreateSavedFilterRequestFilterJson;
}

export type UpdateSavedFilterRequestFilterJson = { [key: string]: unknown };

export interface UpdateSavedFilterRequest {
  name?: string;
  isShared?: boolean;
  filterJson?: UpdateSavedFilterRequestFilterJson;
}

export interface UpdateAdminSettingsRequest {
  /** New support notification email. Send null or empty string to clear and fall back to the env var. */
  supportEmail?: string | null;
  /**
   * New interval (in hours) for the backup verification cron. Send null to clear the override and fall back to the default. Takes effect on next server restart.
   * @minimum 1
   * @maximum 168
   */
  backupVerifyIntervalHours?: number | null;
  /**
   * Yellow threshold in days. Send null to reset to default.
   * @minimum 1
   * @maximum 365
   */
  staleYellowDays?: number | null;
  /**
   * Red threshold in days. Send null to reset to default.
   * @minimum 1
   * @maximum 365
   */
  staleRedDays?: number | null;
  reportsSchedule?: ReportsScheduleConfig;
  /**
   * Days before expiry to warn admins. Send null to reset to default.
   * @minimum 1
   * @maximum 365
   */
  credentialWarnDays?: number | null;
  /**
   * Maximum age in days for the encryption key. Send null to reset to default.
   * @minimum 1
   * @maximum 3650
   */
  encryptionKeyMaxAgeDays?: number | null;
  /**
   * Maximum age in days for mailbox OAuth tokens. Send null to reset to default.
   * @minimum 1
   * @maximum 3650
   */
  mailboxTokenMaxAgeDays?: number | null;
  /**
   * Maximum age in days for Salesforce credentials. Send null to reset to default.
   * @minimum 1
   * @maximum 3650
   */
  sfCredentialMaxAgeDays?: number | null;
}

export type EmailProviderConfigProvider =
  (typeof EmailProviderConfigProvider)[keyof typeof EmailProviderConfigProvider];

export const EmailProviderConfigProvider = {
  sendgrid: "sendgrid",
  mailgun: "mailgun",
  postmark: "postmark",
  resend: "resend",
  smtp: "smtp",
} as const;

/**
 * Where the active configuration comes from.
 */
export type EmailProviderConfigSource =
  (typeof EmailProviderConfigSource)[keyof typeof EmailProviderConfigSource];

export const EmailProviderConfigSource = {
  db: "db",
  env: "env",
  none: "none",
} as const;

export interface EmailProviderConfig {
  provider: EmailProviderConfigProvider;
  fromName: string;
  fromAddress: string;
  /** Where the active configuration comes from. */
  source: EmailProviderConfigSource;
  /** Whether an API key is currently saved (secrets are never returned in plaintext). */
  hasApiKey?: boolean | null;
  mailgunDomain?: string | null;
  smtpHost?: string | null;
  smtpPort?: number | null;
  smtpUseTls?: boolean | null;
  smtpUsername?: string | null;
  /** Whether an SMTP password is currently saved. */
  hasSmtpPassword?: boolean | null;
}

export type UpdateEmailProviderConfigRequestProvider =
  (typeof UpdateEmailProviderConfigRequestProvider)[keyof typeof UpdateEmailProviderConfigRequestProvider];

export const UpdateEmailProviderConfigRequestProvider = {
  sendgrid: "sendgrid",
  mailgun: "mailgun",
  postmark: "postmark",
  resend: "resend",
  smtp: "smtp",
} as const;

export interface UpdateEmailProviderConfigRequest {
  provider: UpdateEmailProviderConfigRequestProvider;
  fromName?: string;
  fromAddress: string;
  /** Leave blank to keep the existing saved key. */
  apiKey?: string | null;
  mailgunDomain?: string | null;
  smtpHost?: string | null;
  smtpPort?: number | null;
  smtpUseTls?: boolean | null;
  smtpUsername?: string | null;
  /** Leave blank to keep the existing saved password. */
  smtpPassword?: string | null;
}

export interface TestEmailSendRequest {
  /** Recipient email address for the test email. */
  to: string;
}

export interface TestEmailSendResult {
  ok: boolean;
  provider?: string | null;
  messageId?: string | null;
  error?: string | null;
  code?: string | null;
}

export interface BuiltInMcpStatus {
  baseUrl: string;
  reachable: boolean;
  transport: string;
  error?: string | null;
}

export type ExternalMcpServerAuthType =
  (typeof ExternalMcpServerAuthType)[keyof typeof ExternalMcpServerAuthType];

export const ExternalMcpServerAuthType = {
  none: "none",
  bearer: "bearer",
  header: "header",
} as const;

export interface ExternalMcpServer {
  id: string;
  name: string;
  baseUrl: string;
  authType: ExternalMcpServerAuthType;
  hasCredential: boolean;
  enabled: boolean;
  lastTestedAt?: string | null;
  lastTestStatus?: string | null;
  lastTestError?: string | null;
  createdAt: string;
  updatedAt: string;
  createdByEmail?: string | null;
}

export type CreateExternalMcpServerRequestAuthType =
  (typeof CreateExternalMcpServerRequestAuthType)[keyof typeof CreateExternalMcpServerRequestAuthType];

export const CreateExternalMcpServerRequestAuthType = {
  none: "none",
  bearer: "bearer",
  header: "header",
} as const;

export interface CreateExternalMcpServerRequest {
  name: string;
  baseUrl: string;
  authType?: CreateExternalMcpServerRequestAuthType;
  credential?: string;
  enabled?: boolean;
}

export type UpdateExternalMcpServerRequestAuthType =
  (typeof UpdateExternalMcpServerRequestAuthType)[keyof typeof UpdateExternalMcpServerRequestAuthType];

export const UpdateExternalMcpServerRequestAuthType = {
  none: "none",
  bearer: "bearer",
  header: "header",
} as const;

export interface UpdateExternalMcpServerRequest {
  name?: string;
  baseUrl?: string;
  authType?: UpdateExternalMcpServerRequestAuthType;
  credential?: string;
  clearCredential?: boolean;
  enabled?: boolean;
}

export interface ExternalMcpTestResult {
  reachable: boolean;
  error?: string | null;
  testedAt: string;
}

export interface McpToken {
  id: string;
  userId: string;
  userEmail: string;
  userName?: string | null;
  label?: string | null;
  lastFour: string;
  createdAt: string;
  lastUsedAt?: string | null;
  revokedAt?: string | null;
  createdByEmail?: string | null;
}

export interface CreateMcpTokenRequest {
  /** TDM user id (uuid) the token will be issued for */
  userId: string;
  /** Optional friendly label (e.g. "Claude Desktop") */
  label?: string;
}

export interface CreateMcpTokenResult {
  /** The plain-text token. Shown ONCE on creation. */
  token: string;
  record: McpToken;
}

export interface UpdateAdminUserRequest {
  isAdmin: boolean;
}

export interface AdminUser {
  id: string;
  email: string;
  name?: string | null;
  isAdmin: boolean;
  /** True if the user is bootstrapped as admin via the ADMIN_EMAILS env var; their admin status cannot be revoked from the UI. */
  isFromEnv: boolean;
}

export interface UploadUrlRequest {
  name: string;
  size: number;
  contentType: string;
}

export interface UploadUrlResult {
  uploadURL: string;
  objectPath: string;
}

export type SupportTicketType =
  (typeof SupportTicketType)[keyof typeof SupportTicketType];

export const SupportTicketType = {
  bug: "bug",
  feature_request: "feature_request",
  other: "other",
} as const;

export type SupportTicketPriority =
  (typeof SupportTicketPriority)[keyof typeof SupportTicketPriority];

export const SupportTicketPriority = {
  low: "low",
  medium: "medium",
  high: "high",
  urgent: "urgent",
} as const;

export type SupportTicketStatus =
  (typeof SupportTicketStatus)[keyof typeof SupportTicketStatus];

export const SupportTicketStatus = {
  open: "open",
  in_progress: "in_progress",
  resolved: "resolved",
  closed: "closed",
} as const;

export interface SupportTicket {
  id: string;
  type: SupportTicketType;
  title: string;
  description: string;
  priority: SupportTicketPriority;
  status: SupportTicketStatus;
  attachmentPath?: string;
  attachmentName?: string;
  attachmentContentType?: string;
  submitterName: string;
  submitterEmail: string;
  createdAt: string;
  updatedAt: string;
}

export interface SupportTicketMessage {
  id: string;
  ticketId: string;
  body: string;
  isInternal: boolean;
  authorName: string;
  authorEmail: string;
  createdAt: string;
}

export type SupportTicketDetail = SupportTicket & {
  messages: SupportTicketMessage[];
};

export interface CreateSupportTicketRequest {
  type: SupportTicketType;
  /**
   * @minLength 1
   * @maxLength 200
   */
  title: string;
  /**
   * @minLength 1
   * @maxLength 5000
   */
  description: string;
  priority: SupportTicketPriority;
  attachmentPath?: string;
  attachmentName?: string;
  attachmentContentType?: string;
}

export interface UpdateTicketStatusRequest {
  status: SupportTicketStatus;
}

export interface AddTicketMessageRequest {
  /**
   * @minLength 1
   * @maxLength 5000
   */
  body: string;
  isInternal?: boolean;
}

export interface CatalogProduct {
  id: string;
  name: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateCatalogProductRequest {
  /**
   * @minLength 1
   * @maxLength 100
   */
  name: string;
}

export interface UpdateCatalogProductRequest {
  /**
   * @minLength 1
   * @maxLength 100
   */
  name: string;
}

export interface BulkAddCatalogProductsRequest {
  names: string[];
}

export type BulkAddCatalogProductsResultInvalidItem = {
  name: string;
  reason: string;
};

export interface BulkAddCatalogProductsResult {
  created: number;
  skippedDuplicates: number;
  invalid: BulkAddCatalogProductsResultInvalidItem[];
}

export type PreviewBulkAddCatalogProductsResultDuplicatesItemReason =
  (typeof PreviewBulkAddCatalogProductsResultDuplicatesItemReason)[keyof typeof PreviewBulkAddCatalogProductsResultDuplicatesItemReason];

export const PreviewBulkAddCatalogProductsResultDuplicatesItemReason = {
  existing: "existing",
  repeated: "repeated",
} as const;

export type PreviewBulkAddCatalogProductsResultDuplicatesItem = {
  name: string;
  reason: PreviewBulkAddCatalogProductsResultDuplicatesItemReason;
};

export type PreviewBulkAddCatalogProductsResultInvalidItem = {
  name: string;
  reason: string;
};

export interface PreviewBulkAddCatalogProductsResult {
  /** Names that would be added (not already in the catalog and not duplicated within the request). */
  newNames: string[];
  /** Names that already exist in the catalog or are repeated within the request, and would be skipped. */
  duplicates: PreviewBulkAddCatalogProductsResultDuplicatesItem[];
  invalid: PreviewBulkAddCatalogProductsResultInvalidItem[];
}

export type GetMailboxOauthStatus200 = {
  google: boolean;
  microsoft: boolean;
};

export type StartMailboxOauthParams = {
  provider: StartMailboxOauthProvider;
};

export type StartMailboxOauthProvider =
  (typeof StartMailboxOauthProvider)[keyof typeof StartMailboxOauthProvider];

export const StartMailboxOauthProvider = {
  google: "google",
  microsoft: "microsoft",
} as const;

export type StartMailboxOauth200 = {
  authorizeUrl: string;
};

export type GetMailboxOauthRedirects200 = {
  google: string;
  microsoft: string;
  googleConfigured: boolean;
  microsoftConfigured: boolean;
};

export type SearchSalesforceOpportunitiesParams = {
  q: string;
};

export type SearchSalesforceOpportunities200 = {
  results: SalesforceOpportunitySummary[];
};

export type SearchChannelManagersParams = {
  q?: string;
};

export type SearchChannelManagers200 = {
  results: ChannelManager[];
};

export type DeleteSalesforceConfig200 = {
  success: boolean;
};

export type ListSavedFilters200 = {
  results: SavedFilter[];
};

export type ListDealsParams = {
  q?: string;
  /**
   * Filter by staleness. "true" returns yellow+red deals; "red" returns only red (past the red threshold) deals.
   */
  stale?: ListDealsStale;
};

export type ListDealsStale =
  (typeof ListDealsStale)[keyof typeof ListDealsStale];

export const ListDealsStale = {
  true: "true",
  false: "false",
  red: "red",
} as const;

export type ListDeals200 = {
  results: Deal[];
};

export type ListRegistrationsParams = {
  status?: string;
  dealId?: string;
  technology?: string;
  supplierContactId?: string;
  sentFrom?: string;
  sentTo?: string;
  q?: string;
  scope?: ListRegistrationsScope;
};

export type ListRegistrationsScope =
  (typeof ListRegistrationsScope)[keyof typeof ListRegistrationsScope];

export const ListRegistrationsScope = {
  mine: "mine",
  all: "all",
} as const;

export type ListRegistrations200 = {
  results: Registration[];
};

export type ListRegistrationJobStatusesParams = {
  /**
   * Comma-separated registration IDs (max 200).
   */
  ids: string;
};

export type GetRegistrationJobStatus200 = {
  status?: RegistrationJobStatus | null;
};

export type RetryRegistrationSend200 = {
  ok: boolean;
  status?: RegistrationJobStatus | null;
};

export type ListTemplatesParams = {
  purpose?: ListTemplatesPurpose;
};

export type ListTemplatesPurpose =
  (typeof ListTemplatesPurpose)[keyof typeof ListTemplatesPurpose];

export const ListTemplatesPurpose = {
  registration: "registration",
  follow_up: "follow_up",
  internal_notification: "internal_notification",
  requester_summary: "requester_summary",
} as const;

export type ListTemplates200 = {
  results: TechnologyTemplate[];
};

export type NotifyRepForRegistration200 = {
  sent: boolean;
  reason?: string;
};

export type GetDashboardSummaryParams = {
  scope?: GetDashboardSummaryScope;
};

export type GetDashboardSummaryScope =
  (typeof GetDashboardSummaryScope)[keyof typeof GetDashboardSummaryScope];

export const GetDashboardSummaryScope = {
  mine: "mine",
  all: "all",
} as const;

export type GetRecentActivityParams = {
  scope?: GetRecentActivityScope;
  limit?: number;
};

export type GetRecentActivityScope =
  (typeof GetRecentActivityScope)[keyof typeof GetRecentActivityScope];

export const GetRecentActivityScope = {
  mine: "mine",
  all: "all",
} as const;

export type GetRecentActivity200 = {
  results: ActivityItem[];
};

export type GetReportRegistrationsOverTimeParams = {
  from?: string;
  to?: string;
  supplierId?: string;
  format?: GetReportRegistrationsOverTimeFormat;
};

export type GetReportRegistrationsOverTimeFormat =
  (typeof GetReportRegistrationsOverTimeFormat)[keyof typeof GetReportRegistrationsOverTimeFormat];

export const GetReportRegistrationsOverTimeFormat = {
  json: "json",
  csv: "csv",
} as const;

export type GetReportSupplierLeaderboardParams = {
  from?: string;
  to?: string;
  supplierId?: string;
  format?: GetReportSupplierLeaderboardFormat;
};

export type GetReportSupplierLeaderboardFormat =
  (typeof GetReportSupplierLeaderboardFormat)[keyof typeof GetReportSupplierLeaderboardFormat];

export const GetReportSupplierLeaderboardFormat = {
  json: "json",
  csv: "csv",
} as const;

export type GetReportTimingParams = {
  from?: string;
  to?: string;
  supplierId?: string;
  format?: GetReportTimingFormat;
};

export type GetReportTimingFormat =
  (typeof GetReportTimingFormat)[keyof typeof GetReportTimingFormat];

export const GetReportTimingFormat = {
  json: "json",
  csv: "csv",
} as const;

export type GetReportFollowUpImpactParams = {
  from?: string;
  to?: string;
  supplierId?: string;
  format?: GetReportFollowUpImpactFormat;
};

export type GetReportFollowUpImpactFormat =
  (typeof GetReportFollowUpImpactFormat)[keyof typeof GetReportFollowUpImpactFormat];

export const GetReportFollowUpImpactFormat = {
  json: "json",
  csv: "csv",
} as const;

export type GetReportRepPerformanceParams = {
  from?: string;
  to?: string;
  supplierId?: string;
  format?: GetReportRepPerformanceFormat;
};

export type GetReportRepPerformanceFormat =
  (typeof GetReportRepPerformanceFormat)[keyof typeof GetReportRepPerformanceFormat];

export const GetReportRepPerformanceFormat = {
  json: "json",
  csv: "csv",
} as const;

export type GetReportPipelineByMonthParams = {
  from?: string;
  to?: string;
  supplierId?: string;
  format?: GetReportPipelineByMonthFormat;
};

export type GetReportPipelineByMonthFormat =
  (typeof GetReportPipelineByMonthFormat)[keyof typeof GetReportPipelineByMonthFormat];

export const GetReportPipelineByMonthFormat = {
  json: "json",
  csv: "csv",
} as const;

export type ListSuppliersParams = {
  q?: string;
  page?: number;
  pageSize?: number;
};

export type ListSuppliers200 = {
  adminEmailConfigured: boolean;
  results: TdmSupplier[];
  /** Total number of suppliers matching the query */
  total: number;
  page: number;
  pageSize: number;
};

export type ListSalesforceAccountsForImportParams = {
  q?: string;
};

export type ListSalesforceAccountsForImport200 = {
  results: SfAccountForImport[];
};

export type CheckSupplierDuplicates200 = {
  candidates: MatchCandidate[];
};

export type BulkImportSalesforceSuppliers200 = {
  created: number;
  linked: number;
  skipped: number;
  /** Number of created suppliers flagged as "Needs review" (near-match) */
  flagged?: number;
  suppliers?: TdmSupplier[];
};

export type RequestSupplierSfAdd200 = {
  sent: boolean;
};

export type ExportRegistrationsCsvParams = {
  status?: string;
  technology?: string;
  supplierContactId?: string;
  sentFrom?: string;
  sentTo?: string;
  q?: string;
};

export type DeleteExternalMcpServer200 = {
  success: boolean;
};

export type RevokeMcpToken200 = {
  success: boolean;
};

export type ListAuditLogParams = {
  actorId?: string;
  actorEmail?: string;
  action?: string;
  from?: string;
  to?: string;
  limit?: number;
  offset?: number;
};

export type ListAllTicketsParams = {
  status?: string;
  type?: string;
  priority?: string;
};
